export default __webpack_public_path__ + "static/UnitedWayLogo-f8ae7452439d67e9b31de22c485c3939.png";